import { ref, onBeforeMount } from 'vue-demi';
const { useVariable } = require('@fegobull/webapi').use;
const { plugins: { weblib } } = require('@futuweb/fego-render');
const { nnq: NNQ } = weblib['@futuweb/tool-nn'];
import { UP_DOWN_COLOR } from '../common/enum';

export default (props) => {
    const { IS_NN, IS_MOOMOO } = useVariable();

    const upDownColor = ref(props.upDownColor);
    const setUpDownColor = () => {
        // 执行
        const run = () => {
            window.NNWebViewJSBridge.callHandler('getUpDownType', {}, (res) => {
                try {
                    const { result, data } = JSON.parse(res) || {};
                    // data: 涨跌色，0-红涨绿跌, 1-绿涨红跌, 2-粉涨绿跌, 3-绿涨粉跌
                    if (result === 0) {
                        upDownColor.value = [0, 2].includes(data) ? UP_DOWN_COLOR.RED_UP : UP_DOWN_COLOR.GREEN_UP;
                    }
                } catch (e) {
                    console.error(e);
                }
            });
        };
        if (window?.NNWebViewJSBridge?.callHandler) {
            run();
        } else {
            NNQ.initBridge({}, () => {
                run();
            });
        }
    };

    (IS_NN || IS_MOOMOO) && onBeforeMount(setUpDownColor);
    return {
        calcUpDownColor: upDownColor
    };
};
